import React, { useState, useEffect } from 'react';
import config from '../../assets/config.json'
import styles from './LastUpdated.module.scss';

const LastUpdated = (props) => {
  const [text, setText] = useState<String>('Last Updated: ');
  Promise.resolve(props.webmap.load()).then(() => {
    // const sitesLayer = props.webmap.layers.find(e => e.title === "Sites");
    const sitesLayer = props.webmap.layers.items.find(
      (e) => e.allLayers && e.allLayers.items.find(
        (p: any) => p.title === config.layerNames.sitesLayer.title
        )
    )
    .allLayers.items.find(
      (p: any) => p.title === config.layerNames.sitesLayer.title
      )
    ;
    sitesLayer.when(() => {
      setText('Last Updated: ' + new Date(sitesLayer.editingInfo.lastEditDate).toLocaleDateString());
    });
  })
    .catch((e) => { console.log('error in promise: ', JSON.parse(JSON.stringify(e))) });

  useEffect(() => { }, [/*layerLoaded, */text])

  return (
    <div className={styles.lastUpdatedDiv}>
      <label className={styles.lastUpdatedLabel}>{text}</label>
    </div>
  )
}

export default LastUpdated;
